import React from "react";

import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormSmallTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormSmallTextBox";
import {EndAdornment} from "../components/ui/EndAdornment"

const preperationForm = (t: any): IDynamicFormRow[] => {
  return [
    {
      label: "forms.orders.preptime",
      keyName: "food_prep_time",
      Component: FormSmallTextBox,
      formProps: {
        sideLabel: "forms.orders.preptime",
        secondLabel: "forms.orders.preptimeinfo",
      },
      inputProperties: {
        type: "number",
        inputProps: { min: 0},
        InputProps: {
          endAdornment: <EndAdornment text={t("forms.orders.preptimeUnit")}/>,
        },
      }, 
      registerOptions: { min: 0 },
    },
  ];
};

export default preperationForm;
